import { render, staticRenderFns } from "./stackPolarBar.md?vue&type=template&id=53b642d3&"
import script from "./stackPolarBar.md?vue&type=script&lang=js&"
export * from "./stackPolarBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b642d3')) {
      api.createRecord('53b642d3', component.options)
    } else {
      api.reload('53b642d3', component.options)
    }
    module.hot.accept("./stackPolarBar.md?vue&type=template&id=53b642d3&", function () {
      api.rerender('53b642d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/polarBar/stackPolarBar.md"
export default component.exports